module.exports = __webpack_public_path__ + "img/canton.c8a6988c.png";